/**
 * «Invita y gana» (2-10-2026): el enlace de un amigo es https://whappscan.com/<lang>/?ref=<código de 8 caracteres>.
 * Al aterrizar se guarda en una cookie de primera parte (.whappscan.com, 30 días, SameSite=Lax) y de ahí viaja al
 * registro (`signupUrl` la añade como &ref=; la app también la lee de la cookie si /signup llega sin parámetros).
 * Gana el ENLACE MÁS RECIENTE: si alguien llega por dos amigos distintos, vale el último.
 */
const COOKIE = "ws_ref";
const MAX_AGE = 30 * 86400;
const CODE_RE = /^[a-z2-7]{8}$/i;

function cookieDomain() {
  const h = window.location.hostname;
  return h === "whappscan.com" || h.endsWith(".whappscan.com") ? "; Domain=.whappscan.com" : "";
}

export function captureReferral() {
  try {
    const q = new URLSearchParams(window.location.search).get("ref");
    if (!CODE_RE.test(q || "")) return;
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${COOKIE}=${q.toLowerCase()}; Max-Age=${MAX_AGE}; Path=/; SameSite=Lax${cookieDomain()}${secure}`;
    if (window.gtag) window.gtag("event", "referral_landing");
  } catch {
    // sin cookies: el enlace sigue funcionando si el visitante se registra en esa misma visita (?ref= en la URL)
  }
}

export function readReferral() {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=([a-z2-7]{8})`, "i"));
    return m ? m[1].toLowerCase() : null;
  } catch {
    return null;
  }
}
